import React from "react";
import { TButtonProps } from "types/Components/Common/Button";

const BorderedButton = ({
  type = "button",
  border = "2",
  id = "",
  onClick,
  disabled = false,
  className=`!tw-border-primary hover:!tw-bg-primary !tw-text-primary hover:!tw-text-white`,
  disabledClassName = "!tw-border-primary-disabled !tw-text-primary-disabled",
  children,
  color,
}: TButtonProps) => {
  return (
      <button
        type={type}
        className={`
        tw-bg-white tw-border tw-rounded  tw-box-border
         tw-cursor-pointer tw-inline-block tw-font-noto-sans tw-text-sm
        tw-leading-5 tw-min-h-[36px] tw-m-0 focus:tw-outline-none tw-p-2 tw-min-w-[92px] tw-py-1 
         tw-relative tw-text-center tw-no-underline tw-touch-manipulation tw-select-none tw-w-auto tw-font-normal
         ${disabled && disabledClassName} ${className}`}
        id={id}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </button>
  );
};

export default BorderedButton;



